import * as types from '../actions/actionTypes';
import initialState from './initialState';

        
export default function descuentoReducer(state= initialState.descuento, action){
    let newState;
	switch(action.type){
         case types.LOAD_DESCUENTO_LIST_SUCCESS:		
            action.descuento.filtroActivo=state.filtroActivo;
            action.descuento.filtroActual=state.filtroActual;
            action.descuento.showActivos=state.showActivos;
			 action.descuento.paginaActual=action.descuento.pageable.pageNumber;
			 action.descuento.registrosPorPagina=action.descuento.size;
            
            return action.descuento;

        case types.BORRAR_DESCUENTO_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(descuento => descuento.id !== action.descuento.id)];          
			return newState;    
            
        case types.ACTIVAR_DESCUENTO_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(descuento => descuento.id !== action.descuento.id)];          
			 return newState;
            
        case types.SET_FILTRO_DESCUENTO:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}